// extracted by mini-css-extract-plugin
export var container = "_81-0";
export var fallback = "_81-5";
export var fallbackIcon = "_81-6";
export var hidden = "_81-2";
export var image = "_81-3";
export var loaded = "_81-4";
export var placeholder = "_81-1";